import { Table } from 'antd'
import { checkCombinations } from '../utils/Functions'
import { delay } from '../utils/Functions'
import scrollIntoView from 'scroll-into-view'

const DynamicTable = (props) => {
	const {
		onRow,
		segment,
		columns,
		tabStatus,
		searchData,
		tableHeight,
		rowClassName,
		columnProps,
		selectedRowKeys,
		selectedOrders,
		setSelectedRowKeys,
	} = props

	const handleScroll = async () => {
		await delay(100)
		scrollIntoView(document.querySelector('.scroll-row'), {
			align: {
				top: 0,
			},
		})
	}

	let tableAttributes = {
		onRow: onRow,
		size: 'small',
		pagination: false,
		columns: columns(columnProps),
		dataSource: searchData?.data,
		rowKey: (record) => record?._id,
		scroll: { y: tableHeight },
		rowClassName: (record, index) =>
			`align-middle pl-2 ${rowClassName} ${record?._id === selectedRowKeys?.[selectedRowKeys?.length - 1] ? 'scroll-row' : ''}`,
		...(tabStatus === 'issuance' && {
			rowSelection: {
				hideSelectAll: true,
				selectedRowKeys: selectedRowKeys,
				preserveSelectedRowKeys: true,
				onChange: (selectedRowKeys) => {
					handleScroll()
					setSelectedRowKeys(selectedRowKeys)
				},
				getCheckboxProps: (record) => {
					return {
						disabled: checkCombinations({ record, selectedOrders, segment }),
					}
				},
			},
		}),
	}
	return <Table {...tableAttributes} />
}

export default DynamicTable
